import React, { useState } from 'react';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';

const PrivacyPolicyBanner = () => {
  const [hideCookiesMessage, setHideCookiesMessage] = useState(localStorage.getItem("careerCookiesMessage") === "true" ? true : false);

  return (
    <>
      {!hideCookiesMessage && (
        <div style={{position: "sticky", bottom: 0, width: "100%",}}>
          <div style={{height: "auto", backgroundColor: "#303030", textAlign: "center", padding: 15}}>
            <Typography style={{color: "white"}}>
              WebHR.PH uses cookies for functional purposes. By continued use of this website, 
              you agree to our privacy policy and accept our use of such cookies. For further details, click &nbsp;
              <a href="https://jeonsoft.com/privacy_policy/webhr" target="_blank" rel="noopener noreferrer" style={{color: " #0bdf98"}}>Privacy Policy</a>
              &nbsp;
              &nbsp;
              <Button
                color="primary"
                variant="outlined"
                style={{ height: "1.875rem" }}
                onClick={() => {
                  localStorage.setItem("careerCookiesMessage", "true");
                  setHideCookiesMessage(true);
                }}
              >
                Got It
              </Button>
            </Typography>
          </div>
        </div>
      )} 
    </>
  )
}

export default PrivacyPolicyBanner;